import { render, staticRenderFns } from "./InfoBoxClientNoLogins.vue?vue&type=template&id=85b99e10"
import script from "./InfoBoxClientNoLogins.vue?vue&type=script&lang=js"
export * from "./InfoBoxClientNoLogins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports